<template>
  <div class="knowledge-point">
    <span v-if="text" class="knowledge-text">{{ text }}</span>
    <slot></slot>
    <div class="knowledge-icon" @click="showKnowledgeModal = true">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="16" x2="12" y2="12"></line>
        <line x1="12" y1="8" x2="12.01" y2="8"></line>
      </svg>
    </div>

    <KnowledgeModal :show="showKnowledgeModal" :title="title" @close="showKnowledgeModal = false">
      <div class="knowledge-content" v-if="content">{{ content }}</div>
      <div class="knowledge-content formatted" v-else-if="formattedContent" v-html="formattedContentHtml"></div>
      <slot name="modal-content" v-else></slot>
    </KnowledgeModal>
  </div>
</template>

<script>
import KnowledgeModal from './KnowledgeModal.vue';
import { knowledgePoints } from '../content/knowledge';

export default {
  name: 'KnowledgePoint',
  components: {
    KnowledgeModal
  },
  props: {
    text: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: 'Knowledge'
    },
    content: {
      type: String,
      default: null
    },
    // Allows passing a key to use predefined knowledge content
    knowledgeKey: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      showKnowledgeModal: false
    };
  },
  computed: {
    formattedContent() {
      if (this.knowledgeKey && knowledgePoints[this.knowledgeKey]) {
        return knowledgePoints[this.knowledgeKey].content;
      }
      return null;
    },
    formattedContentHtml() {
      if (!this.formattedContent) return '';
      
      // Convert plain text with newlines to HTML
      return this.formattedContent
        .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>') // Convert **text** to <strong>text</strong>
        .replace(/\n\n/g, '</p><p>')
        .replace(/\n([0-9]+)\.\s/g, '</p><h4>$1. ')
        .replace(/\n\s{4}/g, '<br>&nbsp;&nbsp;&nbsp;&nbsp;')
        .replace(/\n/g, '<br>')
        .replace(/<\/h4><br>/g, '</h4><p>')
        .replace(/^/, '<p>')
        .replace(/$/g, '</p>');
    }
  }
}
</script>

<style scoped>
.knowledge-point {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.knowledge-text {
  font-weight: 500;
}

.knowledge-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.2s ease;
  color: #4a90e2;
  width: 24px;
  height: 24px;
  margin-left: 4px;
  font-size: 14px;
  animation: flash 1s infinite;
}

@keyframes flash {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.3;
    transform: scale(1.1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.knowledge-icon:hover {
  color: #357abd;
  animation: none;
  transform: scale(1.1);
}

.knowledge-icon svg {
  width: 20px;
  height: 20px;
}

.knowledge-content {
  color: var(--text);
  line-height: 1.6;
}

.knowledge-content.formatted :deep(h4) {
  color: var(--primary);
  margin: 1.5rem 0 0.75rem;
  font-weight: 600;
}

.knowledge-content.formatted :deep(p) {
  margin-bottom: 1rem;
}
</style> 